import React from "react";
import './Styles/Projects.css';
import img_jinxstocks from '../Components/Images/jinxstocks.png';
import salon from '../Components/Images/salon.png';
import tbm from '../Components/Images/tbm.png';
import hdr from '../Components/Images/hdr.png';
import swadshare from '../Components/Images/swadshare.png';
import img_fleetfix from '../Components/Images/fleetfix.png';

const Projects = () => {

    return (
        <>
            <div id="Projects">
                <h2 data-aos="zoom-in">Projects</h2>
                <div className="slider">
                    <div className="slider_center">
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={img_fleetfix} data-aos="fade-up" data-aos-duration="5000" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">Fleetfix (Industry Collaboration)</p>
                                <p className="project_text">FleetFix is an AI-powered fleet management platform designed to optimize operations, reduce costs, and enhance vehicle reliability. It offers predictive maintenance, route optimization, and performance analytics to help logistics and transportation businesses prevent breakdowns, save fuel, and improve delivery efficiency.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/FleetFix" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={img_jinxstocks} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">JinxStocks</p>
                                <p className="project_text">JinxStocks is a desktop app for tracking and analyzing mock stock data, featuring portfolio management, alerts, and TA4J-based technical analysis. Built with JavaFX and SQL, it enables users to practice trading and export insights through Excel reports.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/JinxStocks" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={salon} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">SalonEase (Palcoa Internship)</p>
                                <p className="project_text">Built a salon booking platform using the MERN stack with WooCommerce integration, enabling users to book appointments and manage services with secure authentication and a responsive UI.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/Salon_website_Palcoa" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    <a href="https://frontend-pgtg.onrender.com/home" target="_blank" className="project_link"><i class="img-icon fa-solid fa-link"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={hdr} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">HandDigit Recognizer</p>
                                <p className="project_text">Web app with AI/ML and Deep Learning, built using React and Flask, trained on the MNIST dataset with 2000+ iterations for higher accuracy. It offers a clean UI with both digit and voice input, making it accessible for visually impaired and physically challenged users. Provides real-time recognition with confidence scores, with future scope to extend for handwritten alphabets.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/HandDigit-Recognizer" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={tbm} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">Travel Budget Manager(AI Suggestion Based)</p>
                                <p className="project_text">Java-based application with AI Suggestion built with Swing, SQL, and Google Maps API,Gemini Api to simplify trip planning. It suggests places, transport, and dining options while generating the complete trip budget. Unique features include real-time cost estimation, interactive itinerary planning, location-based suggestions, and automated budget breakdowns. Designed with an intuitive interface, it ensures smarter and more personalized travel planning.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/Travel-Budget-Manager" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={swadshare} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">SwadShare! (AI-Powered Recipe Platform)</p>
                                <p className="project_text">SwadShare is a community-driven recipe management web app built with Python, Flask, and MongoDB. It supports multi-role access (admin, contributor, user) and allows recipes to be added, liked, shared, and saved. Recipes are organized by categories and cuisines, with detailed instructions and allergen lists. An AI recommendation engine suggests personalized recipes, making cooking discovery smarter, while social features enhance engagement and collaboration.</p>
                                <div className="project_links_div">
                                    <a href="https://github.com/ajinkyaspatil20/SwadShare" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    
                                </div>
                            </div>
                        </div>
                        {/* <div className="slider_element">
                            <div className="slider_element_left">
                                <img src={img4} data-aos="fade-up" data-aos-duration="500" className="slider_img" />
                            </div>
                            <div className="slider_element_right">
                                <p className="project_title">ToDoList</p>
                                <p className="project_text">A To-Do List built to list down our tasks.A basic to do list created using React.js having functionality to Add, Delete, Update list. We can see Completed Tasks and we can Update list any time and clear at one click.</p>
                                <div className="project_links_div">
                                    <a href="#" className="project_link"><i class="img-icon fa-brands fa-github"></i></a>
                                    <a href="https://rememberyourtask.netlify.app/" target="_blank" className="project_link"><i class="img-icon fa-solid fa-link"></i></a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Projects;


{/* <div className="proj_container proj1">
                    <div className="proj_div" data-aos="slide-right">
                        <div className="proj_img proj_img1">
                            <div className="inner inner1">
                                Door Dunes - A NFT Project
                                <div className="showInner">
                                    Door Dunes is a one-of-a-kind and distinctive piece of digital art collection that is offered for sale in OpenSea Marketplace as a non-fungible token (NFT) created on the Ethereum Blockchain.
                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://doordunes.com/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="proj_div" data-aos="slide-left">
                        <div className="proj_img proj_img2">
                            <div className="inner inner1">
                                Movie.Ai - WebApp
                                <div className="showInner">
                                    A Basic Machine Learning Project Movie Recommendation System WebApp build using Python and Reactjs.Based on input movie name it suggests top 5 similar movies.                                    <div className="buttons">
                                        <a className="btn_proj" href="https://gitlab.com/amanpathan526/Movie-Recommendation-System-WebApp">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://gitlab.com/amanpathan526/Movie-Recommendation-System-WebApp">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="proj_container">
                    <div className="proj_div" data-aos="slide-right">
                        <div className="proj_img proj_img3">
                            <div className="inner inner1">
                                Adhyay - A Non-Profit Org.
                                <div className="showInner">
                                    A Educational Website named Adhyay is the non-profit organisation which provides free and quality education all over India.It's a group project built in a competition.                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://amanpathan.github.io/Adhyay.github.io/index.html">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="proj_div" data-aos="slide-left">
                        <div className="proj_img proj_img4">
                            <div className="inner inner1">
                                In-A-Can - A Clone Project
                                <div className="showInner">
                                    In-A-Can is a beverages company which provides Crafted Canned Cocktails. This Website is a clone of their official Website.                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://in-a-can.netlify.app/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="proj_container">
                    <div className="proj_div" data-aos="slide-right">
                        <div className="proj_img proj_img5">
                            <div className="inner">
                                Remember Your Task
                                <div className="showInner">
                                    A To-Do List built to list down our tasks.A basic to do list created using React.js having functionality to Add, Delete, Update list. We can see Completed Tasks and we can Update list any time and clear at one click.
                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://rememberyourtask.netlify.app/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="proj_div" data-aos="slide-left">
                        <div className="proj_img proj_img6">
                            <div className="inner">
                                Cloud Journal
                                <div className="showInner">
                                    Weather Forescasting App named<br></br> `Cloud Journal` where we can see weather of current location and search weather of other cities. API used in this app is  WeatherAPI.
                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://cloudjournal.netlify.app/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="proj_container">
                    <div className="proj_div" data-aos="slide-right">
                        <div className="proj_img proj_img7">
                            <div className="inner">
                                Kingdom Hotels
                                <div className="showInner">
                                    It's a Hotel's Website where we can see and book hotel rooms as per our need.It's A static website made using HTML and CSS, It has no backend.
                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://kingdomhotels.netlify.app/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="proj_div" data-aos="slide-left">
                        <div className="proj_img proj_img8">
                            <div className="inner">
                                Covid News App
                                <div className="showInner">
                                    A basic API integrated Webapp which tells us latest updates of Covid-19.It shares current data regarding number of Activd or Confirmed Cases,Deaths,Recoveries,.
                                    <div className="buttons">
                                        <a className="btn_proj" href="#">GitHub <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                        <a className="btn_proj" href="https://amanpathan.github.io/covidapp/">See <i class="fa-solid fa-arrow-right arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}